import { render, staticRenderFns } from "./CustomStylesValidation.vue?vue&type=template&id=5a43e540"
import script from "./CustomStylesValidation.vue?vue&type=script&lang=js"
export * from "./CustomStylesValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports